import { useEffect } from "react";
import { DEFAULT_SEO, SITE_URL, type PageSeo } from "@/lib/seo";

const upsertMeta = (attribute: "name" | "property", key: string, content: string) => {
  const selector = `meta[${attribute}="${key}"]`;
  let element = document.querySelector(selector) as HTMLMetaElement | null;

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

const upsertCanonical = (href: string) => {
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }

  link.setAttribute("href", href);
};

export const usePageSeo = (seo: PageSeo) => {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${seo.path === "/" ? "" : seo.path}`;
    const robots = seo.noindex ? "noindex, nofollow" : "index, follow";

    document.title = seo.title;
    upsertCanonical(canonicalUrl);
    upsertMeta("name", "description", seo.description);
    upsertMeta("name", "robots", robots);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", canonicalUrl);
    upsertMeta("property", "og:title", seo.title);
    upsertMeta("property", "og:description", seo.description);
    upsertMeta("property", "og:image", DEFAULT_SEO.image);
    upsertMeta("property", "twitter:card", "summary_large_image");
    upsertMeta("property", "twitter:url", canonicalUrl);
    upsertMeta("property", "twitter:title", seo.title);
    upsertMeta("property", "twitter:description", seo.description);
    upsertMeta("property", "twitter:image", DEFAULT_SEO.image);
  }, [seo]);
};
